<template>
  <div class="toolIconBox">
    <a
      v-show="showSet"
      @click="showSet = !showSet"
      class="btn cur"
      style="height: 100%;"
    >
      <i
        class="iconfont iconguanbi"
        style="text-align: center;font-size: 30px"
      ></i>
    </a>
    <a
      v-show="!showSet"
      @click="showSet = !showSet"
      class="btn"
      style="height: 100%;"
    >
      <!-- <i class="toolIcon" style="top: 16px;text-align: center;"></i> -->
      <i
        class="iconfont iconshezhi1"
        style="text-align: center;font-size: 30px"
      ></i>
    </a>

    <div v-show="showSet" class="setBox">
      <div class="set-item" v-show="page_config.tileImg">
        <div class="set-item-title">
          {{ page_config.tileImg ? page_config.tileImg.title : "平面图" }}：
        </div>
        <el-switch v-model="showMapTileCtl"></el-switch>
      </div>
      <div class="set-item" v-show="page_config.showHYBRID_MAP">
        <div class="set-item-title">卫星图：</div>
        <el-switch v-model="showHYBRID_MAPCtl"></el-switch>
      </div>
      <div
        class="set-item"
        v-show="user_power.controls.showGf"
        style="display: flex;min-width: 320px"
      >
        <div class="set-item-title">标站：</div>
        <el-switch
          v-model="showGfMapCtl"
          style="height: 40px;line-height: 40px;"
        ></el-switch>
        <el-checkbox-group
          v-model="gfLevelList"
          v-show="showGfMapCtl"
          @change="v => $emit('update:gfLevelList', v)"
        >
          <el-checkbox
            :label="name"
            v-for="name in gfLevelOptions"
            :key="name"
            style="margin: 0 4px;"
            class="custom-checkbox"
            >{{ name + "控" }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
const gfLevelOptions = ["国", "省", "市"];

export default {
  data() {
    return {
      showSet: false,
      gfLevelOptions,
      gfLevelList: []
    };
  },
  computed: {
    ...mapState([
      "page_config",
      "showMapTile",
      "showHYBRID_MAP",
      "showGfStation",
      "user_power"
    ]),
    showMapTileCtl: {
      get() {
        return this.showMapTile;
      },
      set(v) {
        this.$store.commit("setShowMapTile", v);
      }
    },
    showHYBRID_MAPCtl: {
      get() {
        return this.showHYBRID_MAP;
      },
      set(v) {
        this.$store.commit("setShowHYBRID_MAP", v);
      }
    },
    showGfMapCtl: {
      get() {
        return this.showGfStation;
      },
      set(v) {
        this.$store.commit("setShowGfMAP", v);
      }
    }
  },
  watch: {
    showGfMapCtl(v) {
      if (v) {
        this.gfLevelList = this.gfLevelOptions;
      } else {
        this.gfLevelList = [];
      }
      this.$emit("update:gfLevelList", this.gfLevelList);
    },
    gfLevelList(v) {
      if (!v.length) {
        this.$store.commit("setShowGfMAP", false);
      }
    }
  },
  methods: {}
};
</script>

<style lang="less" scoped>
a:hover {
  color: white !important;
}

.setBox {
  padding: 15px 5px 15px 15px;
  border-radius: 0 5px 5px 5px;
  border: 15px solid transparent;
  border-image: url("http://webfron.czczh.net/static/images/border/popBoxBg.png")
    30 fill round;
  position: absolute;
  right: 0;
  // height: 28vh;
  // height: 12vh;
  width: 15.625vw;
  min-width: 320px;
  // z-index: 10000;
  font-size: 17px;

  .set-item {
    min-height: 40px;
    line-height: 40px;

    .set-item-title {
      display: inline-block;
      // width: 100px;
    }
  }
}
.toolIconBox {
  text-align: left;
  position: absolute;
  top: 2.136vh;
  right: 25px;
  display: inline-block;
  // cursor: pointer;
  background: rgba(39, 70, 115, 0.9);
  color: #fff;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  border-radius: 5px;

  &:hover {
    text-decoration: none;
    background-color: #03afff;
  }
}

.btn {
  border-radius: 5px;
  display: inline-block;
  width: 50px;
  text-align: center;
}
.btn:hover {
  text-decoration: none;
}

.compositeTools .toolNav li a:hover,
.compositeTools .linkBtnBox a:hover,
.toolIconBox a:hover {
  text-decoration: none;
  background-color: #03afff;
}

.compositeTools .linkBtnBox a,
.toolIconBox a {
  background: rgba(39, 70, 115, 0.9);
  color: #fff;
}

.toolIconBox a.cur {
  background-color: #e9304e;
}
.custom-checkbox /deep/ .el-checkbox__label {
  color: #fff !important;
}
</style>
